// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "path[data-v-0445914e] {\n  fill: currentColor;\n}\ncircle[data-v-0445914e] {\n  stroke: currentColor;\n}", ""]);
// Exports
module.exports = exports;
